var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Header"),
      _c("div", { staticClass: "document-content transition-slow" }, [
        _c("div", { staticClass: "card-item document-view" }, [
          _vm.email == null
            ? _c("div", { staticClass: "has-text-centered" }, [
                _c("img", {
                  attrs: {
                    src: require("@/ui/assets/img/unlink.gif"),
                    width: "80",
                  },
                }),
                _c("div", { staticClass: "mt-3 box is-shadowless" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("page-not-found")))]),
                ]),
              ])
            : _vm._e(),
          _vm.email != null
            ? _c("div", { staticClass: "has-text-centered" }, [
                _c("img", {
                  attrs: {
                    src: require("@/ui/assets/img/time.gif"),
                    width: "80",
                  },
                }),
                _c("div", { staticClass: "mt-3 box is-shadowless" }, [
                  _c("h3", { staticClass: "is-size-6-mobile" }, [
                    _vm._v(_vm._s(_vm.$t("expired-credentials-ini")) + " "),
                    _c("strong", [_vm._v(_vm._s(_vm.obscureEmail(_vm.email)))]),
                    _vm._v(" " + _vm._s(_vm.$t("expired-credentials-fin"))),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "my-5 has-text-centered" },
            [
              _c(
                "b-button",
                {
                  staticClass: "px-6 mx-2",
                  attrs: { rounded: "", type: "is-success" },
                  on: {
                    click: function ($event) {
                      return _vm.redirectSimulator()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("simulator-button")))]
              ),
              _c(
                "b-button",
                {
                  staticClass: "px-6 mx-2",
                  attrs: { rounded: "", type: "is-primary", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.redirectHelpCenter()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("help-message-title")))]
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }